import { render } from "./header-comp.vue?vue&type=template&id=dd13feba&scoped=true"
import script from "./header-comp.vue?vue&type=script&lang=js"
export * from "./header-comp.vue?vue&type=script&lang=js"

import "./header-comp.vue?vue&type=style&index=0&id=dd13feba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd13feba"]])

export default __exports__